import { ErrorResponse} from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { UomsAdapter } from './dto/uom.adapter';
import { UomsDTO } from './dto/uom.dto';
import { Uoms } from './uom.entity';
import { UomsResponseModel, AllUomsResponseModel } from '@gtpl/shared-models/masters';
import { UomsRequest } from './dto/uoms.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';

@Injectable()
export class UomsService {
    constructor(
      private logService:LogsService,
        @InjectRepository(Uoms)
        private uomsRepository: Repository<Uoms>,
        private uomsAdapter: UomsAdapter,
    ) { }
    /**
     * create or update Uom
     * @param uomsDTO 
     * @param isUpdate 
     * @param request 
     */
    async createUom(uomsDTO: UomsDTO, isUpdate: boolean, request: Request): Promise<UomsResponseModel> {
        try {
          let previousValue
            // to check whether UOM exists with the passed  UOM  or not. if isUpdate is false, a check will be done whether a record with the passed Department is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Department  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const UomEntity = await this.getUomDetailsWithoutRelations(uomsDTO.uomName);
                if (UomEntity) {
                    throw new UomsResponseModel(false,11104, 'UOM already exists');
                }
            } 
            else{
                const certificatePrevious = await this.uomsRepository.findOne({where:{uomId:uomsDTO.uomId}})
                previousValue = certificatePrevious.uomName+","+certificatePrevious.uomType;
                const UomEntity = await this.getUomDetailsWithoutRelations(uomsDTO.uomName);
                if (UomEntity) {
                    if(UomEntity.uomId!=uomsDTO.uomId){
                        throw new UomsResponseModel(false,11104, 'UOM already exists');
                    }
                }
            } 
            const convertedUomEntity: Uoms = this.uomsAdapter.convertDtoToEntity(uomsDTO, isUpdate);
            const savedUomEntity: Uoms = await this.uomsRepository.save(
                convertedUomEntity
            );
            const savedUomDto: UomsDTO = this.uomsAdapter.convertEntityToDto(savedUomEntity);
            if (savedUomDto) {
            const certificatePresent = savedUomDto.uomName+","+savedUomDto.uomType;
                // generating resposnse
                const response = new UomsResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Uom Updated Successfully' : 'Uom Created Successfully', savedUomDto);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Uom Updated Successfully': 'Uom Created Successfully'
            const userName = isUpdate? savedUomDto.updatedUser :savedUomDto.createdUser;
            const newLogDto = new LogsDto(
                1,                           
                name,                         
                'Uoms',                       
                savedUomDto.uomId,            
                true,                         
                displayValue,                
                userName,                     
                previousValue,                
                certificatePresent           
              );
              
                let res = await this.logService.createLog(newLogDto);
                return response;
            } else {
                throw new UomsResponseModel(false,11106, 'Uom saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get uom details by id
     * @param uomName 
     */
    async getUomDetailsWithoutRelations(uomName: string): Promise<Uoms> {
        // tslint:disable-next-line: typedef
        const UomResponse = await this.uomsRepository.findOne({
            where: { uomName: Raw(alias => `uom_name = "${uomName}"`) },
        });
        if (UomResponse) {
            return UomResponse;
        } else {
            return null;
        }
    }
    /**
     * get All Uoms Details
     */
    async getAllUoms(req?:UserRequestDto): Promise<AllUomsResponseModel> {
        // const page: number = 1;
        try {
            const uomsDTO: UomsDTO[] = [];
            //retrieves all companies
            const uomsEntities: Uoms[] = await this.uomsRepository.find({ order: { uomName: 'ASC' } });
            //console.log(uomsEntities);
            if (uomsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                uomsEntities.forEach(uomEntity => {
                    const convertedstatesDto: UomsDTO = this.uomsAdapter.convertEntityToDto(
                        uomEntity
                    );
                    uomsDTO.push(convertedstatesDto);
                });
                const response = new AllUomsResponseModel(true, 11108, "Uoms retrieved successfully", uomsDTO);
               if(req?.createdUser){
                const newLogDto = new LogsDto(1,'view', 'Uoms', 0, true, 'Uoms retrieved successfully','','',req.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
               } 
           
                return response;
            } else {
                throw new UomsResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getAllActiveUoms(): Promise<AllUomsResponseModel> {
        // const page: number = 1;
        try {
            const uomsEntities: UomsDTO[] = [];
            //retrieves all companies
            const UomsEntities: Uoms[] = await this.uomsRepository.find({ order: { uomName: 'ASC' },
           });
         console.log(UomsEntities)
            if (UomsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                UomsEntities.forEach(uomEntity => {
                    const converteduomsEntities: UomsDTO = this.uomsAdapter.convertEntityToDto(
                      uomEntity
                    );
                    uomsEntities.push(converteduomsEntities);
                });
                const response = new AllUomsResponseModel(true, 11108, "Uoms retrieved successfully", uomsEntities);
                return response;
            } else {
                throw new UomsResponseModel(false,99998, 'Data not found'); uomsEntities
            }
        } catch (err) {
            throw err;
        }
    }
    /**
     * It deactivates Uom 
     * @param uomRequest   as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateUom(uomReq: UomsRequest): Promise<UomsResponseModel> {
        try {
            const uomExists = await this.getUomById(uomReq.uomId);
            if (uomExists) {
                if (uomReq.versionFlag !== uomExists.versionFlag) {
                    throw new UomsResponseModel(false,10113, 'Someone updated the current Uom information.Refresh and try again');
                } else {

                    const uomStatus = await this.uomsRepository.update(
                        { uomId: uomReq.uomId },
                        { isActive: uomReq.isActive, updatedUser: uomReq.updatedUser });

                    if (uomExists.isActive) {
                        if (uomStatus.affected) {
                            const uomResponse: UomsResponseModel = new UomsResponseModel(true, 10115, 'Uom is de-activated successfully');
                            return uomResponse;
                        } else {
                            throw new UomsResponseModel(false,10111, 'Uom is already deactivated');
                        }
                    } else {
                        if (uomStatus.affected) {
                            const uomResponse: UomsResponseModel = new UomsResponseModel(true, 10114, 'Uom is activated successfully');
                            return uomResponse;
                        } else {
                            throw new UomsResponseModel(false,10112, 'Uom is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new UomsResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getActiveUomById(uomReq: UomsRequest): Promise<UomsResponseModel> {
        try {
            //retrieves all companies
            console.log(uomReq);
            const uomId = uomReq.uomId;
            const uomEntities: Uoms = await this.uomsRepository.findOne({
              where:{uomId:uomId}
              });
              console.log(uomEntities);
              const uomData: UomsDTO = this.uomsAdapter.convertEntityToDto(uomEntities);
              if (uomData) {
                  const response = new UomsResponseModel(true, 11101 , 'Product retrived Successfully',uomData);
                  return response;
              }
              else{
                  throw new UomsResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
              
          } catch (err) {
            throw err;
          }
    }
    /**
     * get Uom by id
     * @param uomId 
     */
    async getUomById(uomId: number): Promise<Uoms> {
        const Response = await this.uomsRepository.findOne({
            where: { uomId: uomId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    // async getAllUomsDropDownData(): Promise<UomsResponseModel> {
    //     try {
    //         const uomsDTO: UomsDropDownDto[] = [];
    //         const uomsEntities: Uoms[] = await this.uomsRepository.find({ select: ['uomId', 'uomName'], where: { isActive: true }, order: { 'uomName': 'ASC' } });
    //         if (uomsEntities && uomsEntities.length > 0) {
    //             uomsEntities.forEach(uomEntity => {
    //                 uomsDTO.push(new UomsDropDownDto(uomEntity.uomId,uomEntity.uomName));
    //             });
    //             const response = new UomsResponseModel(true, 11108, "Uoms retrieved successfully", uomsDTO);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data not found');
    //         }
    //     } catch (err) {
    //         throw err;
    //     }
    // }
}
